import adminMedicineList from "./admin-medicine-list/AdminMedicineList.vue";
import adminMedicineListError from "./admin-medicine-list-error/AdminMedicineListError.vue";
import vademecumService from "../../services/vademecum/Vademecum.js";
import { StorageService } from "../../services/StorageService.js";
import fileLog from "../../services/file-log/FileLog";

export default {
  components: { adminMedicineList, adminMedicineListError },
  data: () => ({
    logData: "",
    user: "",
    vademecumData: []
  }),
  methods: {
    openFileChooser() {
      this.$refs.file.click();
    },
    handleFile() {
      vademecumService.uploadVademecum(this.$refs.file.files[0]).then();
    },
    getUserName() {
      const user = StorageService.getUserData();
      this.user = user.id;
    }
  },
  created() {
    this.getUserName();
  }
};
